
const BASEENDPOINT = "/api";
const PAGOS_ENDPOINT = {
    ACTUALIZACIONDATOSACCESO  : BASEENDPOINT + '/actualizacion/acceso',
    POLIZAS  : BASEENDPOINT + '/polizas',
    URLDEACCESO  : BASEENDPOINT + '/token',
    VALIDARURLACCESO  : BASEENDPOINT + '/validartoken',

    //? PAGOS
    PROCESARPAGO : BASEENDPOINT + "/pagos",
    DETALLEPAGO : BASEENDPOINT + "/pagos",

}

export default PAGOS_ENDPOINT;